import rating from 'iztech-design-system-neo/dist/system/i18n/en/rating'

export default {
  ...rating,
  MSG_SEND_LOADING: 'Send to server...',
	MSG_SEND_SUCCESS: 'The system has received your rating',
}